import React, { Fragment, useContext, useMemo } from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import { AppContext } from "../context/AppContext";
import Utils from "../utils/Utils";
import { useNavigate } from "react-router-dom";
import * as Fi from "react-icons/fi";
import { HashLoader } from "react-spinners";
import { MdKeyboardArrowLeft } from "react-icons/md";
import "../styles/style.css";

const DAYS = [
  "sunday",
  "monday",
  "tuesday",
  "wednesday",
  "thursday",
  "friday",
  "saturday",
];

function capitalize(day) {
  return day.charAt(0).toUpperCase() + day.slice(1);
}

function ReservationTimings() {
  const navigate = useNavigate();
  const { reservSettingsLoading, reservFoodpageTiming } =
    useContext(AppContext);

  const dayRows = useMemo(() => {
    if (!reservFoodpageTiming) return [];
    return DAYS.map((day) => {
      const daySlots = reservFoodpageTiming[day] ?? [];
      const activeSlots = daySlots.filter(
        (slot) =>
          slot.status === "active" && slot.openingTime && slot.closingTime
      );
      return { day, activeSlots, isOpen: activeSlots.length > 0 };
    });
  }, [reservFoodpageTiming]);

  const openDays = dayRows.filter((d) => d.isOpen).length;

  return (
    <Fragment>
      <MasterLayout>
        <div className="rs-settings">
          <header className="rs-settings__header">
            <button
              type="button"
              className="rs-settings__back"
              onClick={() => navigate("/reservation-settings")}
            >
              <MdKeyboardArrowLeft /> More
            </button>
            <div className="rs-settings__heading">
              <div className="rs-settings__heading-text">
                <h1 className="rs-settings__title">Reservation timings</h1>
                <p className="rs-settings__subtitle">
                  Weekly opening hours guests can book against.
                </p>
              </div>
              <button
                type="button"
                className="rs-settings__edit"
                onClick={() =>
                  navigate("/edit-reservation-settings?section=timings")
                }
              >
                <Fi.FiEdit3 /> Edit
              </button>
            </div>
          </header>

          {reservSettingsLoading ? (
            <div className="rs-settings__loader">
              <HashLoader color="#f44336" />
            </div>
          ) : dayRows.length > 0 ? (
            <section className="rs-settings-card">
              <div className="rs-settings-card__head">
                <div>
                  <h2 className="rs-settings-card__title">Weekly schedule</h2>
                  <p className="rs-settings-card__meta">
                    {openDays} open day{openDays === 1 ? "" : "s"} ·{" "}
                    {7 - openDays} closed
                  </p>
                </div>
              </div>
              <ul className="rs-timing-list">
                {dayRows.map(({ day, activeSlots, isOpen }) => (
                  <li
                    key={day}
                    className={`rs-timing-day${isOpen ? "" : " is-closed"}`}
                  >
                    <div className="rs-timing-day__left">
                      <span className="rs-timing-day__name">
                        {capitalize(day)}
                      </span>
                      <span
                        className={`rs-timing-day__badge${
                          isOpen ? " is-open" : ""
                        }`}
                      >
                        {isOpen ? "Open" : "Closed"}
                      </span>
                    </div>
                    <div className="rs-timing-day__slots">
                      {isOpen ? (
                        activeSlots.map((slot) => (
                          <span key={slot.slotId} className="rs-settings-pill">
                            {Utils.convertTiming(slot.openingTime)} –{" "}
                            {Utils.convertTiming(slot.closingTime)}
                          </span>
                        ))
                      ) : (
                        <span className="rs-settings-timings__closed">
                          No slots
                        </span>
                      )}
                    </div>
                  </li>
                ))}
              </ul>
            </section>
          ) : (
            <section className="rs-settings-card rs-settings-empty-card">
              <Fi.FiClock className="rs-settings-empty-card__icon" />
              <p className="rs-settings-empty-card__title">No timings yet</p>
              <p className="rs-settings-empty-card__text">
                Set your weekly schedule so guests know when they can book.
              </p>
              <button
                type="button"
                className="rs-settings__edit"
                onClick={() =>
                  navigate("/edit-reservation-settings?section=timings")
                }
              >
                <Fi.FiEdit3 /> Set timings
              </button>
            </section>
          )}
        </div>
      </MasterLayout>
    </Fragment>
  );
}

export default ReservationTimings;
